// ButtonStyled.js
import { alpha, styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ButtonStyled = styled(Button)(
  ({ theme }) =>
    ({ bgColor, color, noHover }) => ({
      width: "max-content",
      margin: "1.4rem auto",
      borderRadius: "4px",
      backgroundColor: bgColor ? bgColor : "#0F84FF",
      color: color ? color : "#fff",
      textTransform: "none",
      padding: "0.5rem 1.5rem",

      fontWeight: "bold",
      "&:hover": {
        backgroundColor: noHover
          ? "none"
          : bgColor
          ? alpha(bgColor, 0.9)
          : alpha("#0F84FF", 0.9),
      },
    })
);
